var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c("p", [
      _vm._v(
        "Haga clic en el evento. Obtendrá mas informacion acerca del mismo antes de ejecutarlo."
      ),
    ]),
    _vm._v(" "),
    _vm.eventosDisponibles.length < _vm.cantEventosDisponiblesSinFiltroAreas &&
    _vm.eventosDisponibles.length == 0 &&
    _vm.cantEventosDisponiblesSinFiltroAreas > 0
      ? _c("p", { staticClass: "is-size-7" }, [
          _c("i", { staticClass: "fas fa-info-circle" }),
          _vm._v(" \n    "),
          _c("b", [_vm._v("Importante:")]),
          _vm._v(
            "\n    Este area no tiene mas eventos para ejecutar. Debe continuar otra area ejecutando eventos\n  "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.eventosDisponibles.length < _vm.cantEventosDisponiblesSinFiltroAreas &&
    _vm.eventosDisponibles.length > 0
      ? _c("p", { staticClass: "is-size-7" }, [
          _c("i", { staticClass: "fas fa-info-circle" }),
          _vm._v(" \n    "),
          _c("b", [_vm._v("Importante:")]),
          _vm._v(
            "\n    Mostrando " +
              _vm._s(_vm.eventosDisponibles.length) +
              " de " +
              _vm._s(_vm.cantEventosDisponiblesSinFiltroAreas) +
              " acciones. Algunos no se muestran porque han sido reestringidas para ser ejecutadas por areas específicas.\n  "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _vm.eventosDisponibles.length > 0
      ? _c(
          "div",
          { staticClass: "buttons is-centered" },
          _vm._l(_vm.eventosDisponibles, function (evento, index) {
            return _c(
              "button",
              {
                key: index,
                staticClass: "button is-primary is-outlined",
                on: {
                  click: function ($event) {
                    return _vm.selectEvento(evento)
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-play-circle fa-fw" }),
                _vm._v(" " + _vm._s(evento.nombre)),
              ]
            )
          }),
          0
        )
      : _c("div", { staticClass: "notification is-light" }, [
          _c("i", { staticClass: "fas fa-exclamation-circle" }),
          _vm._v(" Sin eventos disponibles para ejecutar\n  "),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }